import { render, staticRenderFns } from "./GenerateProblem.vue.js?vue&type=template&id=ac5c95a2!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GenerateProblem.vue?vue&type=template&id=ac5c95a2"
import script from "./GenerateProblem.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GenerateProblem.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateProblem.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GenerateProblem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports